import useAsyncData from "../../../hooks/use-async-data";
import planEntryService from "../plan-entry.service";
import PlanEntryDetails from "./plan-entry-details";
import PlanEntryDetailsParams from "./plan-entry-details-params";

const usePlanEntryDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<PlanEntryDetails | null>(null);

  const load = async (params: PlanEntryDetailsParams, signal: AbortSignal) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const planEntryDetails = await planEntryService.getDetails(
        params,
        signal,
      );

      setData(planEntryDetails);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default usePlanEntryDetails;
